(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modern-wink-christmas"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('mw-holiday-home')) {
  customElements.define('mw-holiday-home', class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.targets = Array.from(this.querySelectorAll('.mw-xmas__copy > *, .mw-xmas__intro > *, .mw-xmas__product-image, .mw-xmas__product-copy > *, .mw-xmas__moments-title > *, .mw-xmas__cards > article, .mw-xmas__closing > *'));
      this.revealAll = () => {
        this.observer?.disconnect();
        this.targets.forEach(el => el.classList.remove('mw-reveal-pending'));
      };
      this.onMotion = () => { if (this.motion.matches) this.revealAll(); };
      if (this.motion.matches || !('IntersectionObserver' in window)) return;
      this.observer = new IntersectionObserver(entries => {
        const visible = entries.filter(entry => entry.isIntersecting);
        visible.forEach((entry, index) => {
          entry.target.style.setProperty('--mw-delay', Math.min(index * 75, 225) + 'ms');
          entry.target.classList.remove('mw-reveal-pending');
          this.observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });
      this.targets.forEach(el => {
        if (el.getBoundingClientRect().bottom <= 0) return;
        el.classList.add('mw-reveal', 'mw-reveal-pending');
        this.observer.observe(el);
      });
      this.motion.addEventListener('change', this.onMotion);
    }
    disconnectedCallback() {
      this.revealAll?.();
      this.motion?.removeEventListener('change', this.onMotion);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-pivotx-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-px-review-more]').forEach((button) => {
    if (button.dataset.ready === 'true') return;
    button.dataset.ready = 'true';
    button.addEventListener('click', () => {
      const grid = button.parentElement.querySelector('[data-px-review-grid]');
      const expanded = grid.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mw-supercar-shower-landing"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-sr-review-more]').forEach((button) => {
    button.addEventListener('click', () => {
      const grid = button.parentElement.querySelector('[data-sr-review-grid]');
      const expanded = grid.classList.toggle('is-expanded');
      button.textContent = expanded ? 'Show fewer reviews' : 'Show more reviews';
    });
  });

  } catch(e) { console.error(e); }
})();
})();
